import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import galleryOne from '../assets/images/performance-marketting.jpg';
import galleryTwo from '../assets/images/mobile.jpg';
import galleryThree from '../assets/images/creative-designs.jpg';
import galleryFour from '../assets/images/branding.jpg';
import galleryFive from '../assets/images/web-development.jpg';
import gallerySix from '../assets/images/seo.jpg';
import gallerySeven from '../assets/images/whats-app.jpg';

gsap.registerPlugin(ScrollTrigger);

const ScrollingCards = () => {
    const [isMobileOrTab, setIsMobileOrTab] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobileOrTab(window.innerWidth <= 991);
        };
        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    useEffect(() => {
        if (isMobileOrTab) {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
            return;
        }
        // Get all horizontally scrolling sections
        const sections = gsap.utils.toArray(".horiz-gallery-wrapper");
        sections.forEach((section) => {
            const wrap = gsap.utils.toArray(".horiz-gallery-strip", section)[0];
            const cards = gsap.utils.toArray(".gallery-card", wrap);
            gsap.set(wrap, { x: 0 });
            let mm = gsap.matchMedia();
            mm.add("(prefers-reduced-motion: no-preference)", () => {
                let totalDistance = 0;
                cards.forEach(card => {
                    totalDistance += card.offsetWidth + 50;
                });
                let t1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "center center",
                        end: () => `+=${totalDistance}`,
                        scrub: 1,
                        pin: true,
                        invalidateOnRefresh: true,
                    },
                });
                t1.to(wrap, {
                    x: () => -totalDistance + window.innerWidth,
                    duration: 1,
                    ease: "none",
                }, 0);
                return () => {
                    t1.kill();
                };
            });
            return () => {
                mm.kill();
            };
        });
        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, [isMobileOrTab]);

    return (
        <div>
            {/* Portfolio Section */}
            <section className="horiz-gallery-wrapper">
                <div
                    className="horiz-gallery-strip"
                    style={isMobileOrTab ? { display: 'flex', flexDirection: 'column', gap: 24 } : {}}
                >
                    <div className="gallery-card" style={{ backgroundImage: `url(${galleryOne}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Performance Marketing</h2>
                                <p className="sub-title">Targeted, optimised, and obsessively monitored campaigns built to skyrocket your ROI.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${galleryTwo}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Social Media Marketing</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${galleryThree}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Creative & Design</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${galleryFour}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Branding & Strategy</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${galleryFive}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Web Development</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${gallerySix}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">Search Engine Optimization</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-card" style={{ backgroundImage: `url(${gallerySeven}` }}>
                        <div className="card-overlay">
                            <div className="text-content">
                                <h2 className="title">WhatsApp Marketing</h2>
                                <p className="sub-title"> Content that stops thumbs, storytelling that builds communities, and strategy that aligns to business goals.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ScrollingCards;
